import React, { useLayoutEffect } from 'react';
import { isEditorActive, Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import ReplaceableText from '../../../utils/text/ReplaceableText';
import { setNextPage, setPrevPage } from '../../../redux/slices/appStateSlice';
import { useDispatch } from 'react-redux';

const ApplySummary = ({ rendering, fields }) => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (isEditorActive()) {
      return;
    }

    if (fields.nextPage?.value) {
      dispatch(setNextPage(fields.nextPage.value.href));
    }

    if (fields.prevPage?.value) {
      dispatch(setPrevPage(fields.prevPage.value.href));
    } else {
      dispatch(setPrevPage(null));
    }
  }, []);

  return (
    <div className="vds-quote-page-hero__quote-container">
      <div className="vds-quote-details-container" data-testid={fields.testid?.value}>
        <div className="vds-quote-details-container__inner">
          <div className="vds-quote-details-container__heading">
            <ReplaceableText
              tag="strong"
              field={fields.planName}
              data-testid={`${fields.testid?.value}-planname`}
            />
            <h2 className="vds-quote-details-container__quote-primary">
              <ReplaceableText
                tag="strong"
                field={fields.monthlyAmount}
                data-testid={`${fields.testid?.value}-monthlyamount`}
                isCurrency={true}
              />
              <Text
                field={fields.monthlyLabel}
                data-testid={`${fields.testid?.value}-monthlylabel`}
              />
            </h2>

            <h3 className="vds-quote-details-container__quote-secondary">
              <ReplaceableText
                tag="strong"
                field={fields.annualAmount}
                data-testid={`${fields.testid?.value}-annualamount`}
                isCurrency={true}
              />
              <Text
                field={fields.annualLabel}
                data-testid={`${fields.testid?.value}-annuallabel`}
              />
            </h3>

            <Text
              tag="p"
              className="vds-quote-details-container__legal-text"
              field={fields.legalText}
              data-testid={`${fields.testid?.value}-legaltext`}
            />
          </div>

          <Placeholder name="apply-summary-content" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

export default ApplySummary;
